// extracted by mini-css-extract-plugin
module.exports = {"container":"_1EfUB","cover":"_2o8QE","coverImage":"_3KxPL","details":"_1t9_M","title":"_3Q6vw","categoryLink":"_3tuq5","statistics":"CQCsY","buttonGroup":"n6bj7"};